<template>
  <div class="information">
    <publicheader :headerInfo="headerInfo"></publicheader>
    <publicloading v-if="loadingIsShow"></publicloading>
    <div style="height:0.88rem">

    </div>
    <div class="desc">
      合并后您的以下账号信息将被合并或清除，请确认以下信息，合并后数据将无法撤回
    </div>
    <!-- 账号信息 -->
    <div class="mergeTitle">账号信息：</div>
    <div class="userInfoBox" v-if="mainUser && otherUser">
      <div class="smallTitle">主账号：</div>
      <div class="userInfo">
        <div class="userImg">
          <img :src="mainUser.userHeadImg" alt="" />
        </div>
        <div class="userName">{{ mainUser.userName }}</div>
      </div>
      <div class="smallTitle">合并账号：</div>
      <div class="userInfo">
        <div class="userImg">
          <img :src="otherUser.userHeadImg" alt="" />
        </div>
        <div class="userName">{{ otherUser.userName }}</div>
      </div>
    </div>
    <!-- 合并信息 -->
    <div class="mergeTitle">合并信息：</div>
    <div class="infoListBox">
      <div class="tips">以下信息将在账号合并后实时更新至新账户</div>
      <div class="infoList">
        <div class="infoHeader">
          <div class="tableItem header item1">项目</div>
          <div class="tableItem lineItem header">
            <div class="title">主账户</div>
            <div class="name">{{ mainUser.userName }}</div>
          </div>
          <div class="tableItem lineItem header">
            <div class="title">合并账户</div>
            <div class="name">{{ otherUser.userName }}</div>
          </div>
          <div class="tableItem header">合并后</div>
        </div>
        <div
          class="rowItem"
          :class="{ evenItem: index % 2 == 1 }"
          v-for="(item, index) in infoList"
          :key="index"
        >
          <div
            class="tableItem"
            :class="{
              redWord: item2 == -1,
              item1: index2 === 0,
              nameOne: index2 === 1 && index === 0,
              nameThree: index2 === 3 && index === 0
            }"
            v-for="(item2, index2) in item"
            :key="index2"
          >
            <span>{{ item2 == -1 ? '× 删除' : item2 }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="infoListBox">
      <div class="tips">以下信息将在合并提交后24小时内更新至新账户</div>
      <div class="infoList">
        <div class="infoHeader">
          <div class="tableItem header item1">项目</div>
          <div class="tableItem lineItem header">
            <div class="title">主账户</div>
            <div class="name">{{ mainUser.userName }}</div>
          </div>
          <div class="tableItem lineItem header">
            <div class="title">合并账户</div>
            <div class="name">{{ otherUser.userName }}</div>
          </div>
          <div class="tableItem header">合并后</div>
        </div>
        <div
          class="rowItem"
          :class="{ evenItem: index % 2 == 1 }"
          v-for="(item, index) in infoList2"
          :key="index"
        >
          <div
            class="tableItem"
            :class="{ redWord: item2 == -1, item1: index2 === 0 }"
            v-for="(item2, index2) in item"
            :key="index2"
          >
            {{ item2 == -1 ? '× 删除' : item2 }}
          </div>
        </div>
      </div>
    </div>
    <!-- 吸底按钮 -->
    <div class="btnBox">
      <div class="btns">
        <div class="btnItem" @click="handelCancel">取消</div>
        <div class="btnItem" :class="{ redBtn: canMerge }" @click="gotoMerge">
          确认合并{{ !canMerge ? `（${cutdown}s）` : '' }}
        </div>
      </div>
    </div>
    <!-- 确认弹窗 -->
    <div class="dialogBox" v-if="infoDialogIsShow">
      <div class="dialog">
        <div class="dTitle">确认合并账号</div>
        <div class="dInfo">
          请确认账号合并信息及处理结果已知晓，合并提交后无法撤回。
        </div>
        <div class="dBtns">
          <div class="btn" @click="cancelMerge">取消</div>
          <div class="btn redone" @click="confirmMerge">确认合并</div>
        </div>
      </div>
    </div>
    <!-- 失败弹窗 -->
    <div class="dialogBox failDialog" v-if="failDialogIsShow">
      <div class="dialog">
        <div class="dTitle">提示</div>
        <div class="dInfo">
          您的账号存在异常信息，请拨打电话：<span
            @click="callPhone('400-801-5553')"
            >400-801-5553</span
          >
          联系工作人员人工合并账号
        </div>
        <div class="dBtns">
          <div class="btn redone" @click="handleCancelMerge">好的</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from 'qs'
import { Toast } from 'vant'
export default {
  name: '',
  data() {
    return {
      infoList: [[], [], [], [], [], [], []],
      infoList2: [
        ['评论/点赞', '保留', -1, '保留主账户'],
        ['默认收货地址', '保留', -1, '保留主账户'],
        ['聊天记录', '保留', -1, '保留主账户'],
        ['发布的内容', '保留', '保留', '保留全部'],
        ['会员等级经验', '保留', '保留', '保留全部'],
        ['会员购买记录', '保留', '保留', '保留全部'],
        ['关注列表', '保留', '保留', '保留全部'],
        ['彩色弹幕', '保留', '保留', '保留全部'],
        ['全服喇叭', '保留', '保留', '保留全部'],
        ['历史订单', '保留', '保留', '保留全部'],
        ['优惠券', '保留', '保留', '保留全部'],
        ['直播间徽章', '保留', '保留', '保留全部'],
        ['进场道具', '保留', '保留', '保留全部'],
        ['直播间挂件', '保留', '保留', '保留全部'],
        ['打赏记录', '保留', '保留', '保留全部'],
        ['礼物记录', '保留', '保留', '保留全部'],
        ['直播间嘉宾', '保留', '保留', '保留全部'],
        ['直播间排行榜', '保留', '保留', '保留全部'],
        ['积分兑换记录', '保留', '保留', '保留全部'],
        ['课程购买记录', '保留', '保留', '保留全部'],
        ['方案购买记录', '保留', '保留', '保留全部'],
        ['数字藏品奖励积分记录', '保留', '保留', '保留全部'],
        ['数字藏品购买记录', '保留', '保留', '保留全部'],
        ['背包礼物', '保留', '保留', '保留全部']
      ],
      cutdown: 10,
      canMerge: false,
      infoDialogIsShow: false,
      failDialogIsShow: false,
      // 主账户信息
      mainUser: '',
      // 子账户信息
      otherUser: '',
      // 当前登录的uid
      loginUid: '',
      token: '',
      headerInfo : {
        title: '信息确认',
        bg: '#FFF',
        fontBlack: true,
        color: ''
      },
      loadingIsShow:false
    }
  },
  computed: {},
  watch: {},
  created() {
    
    this.token = this.getcommit('token') ? this.getcommit('token') : ''
    this.loginUid =
      this.token.split('*')[1] ||
      this.token.split('%2a')[1] ||
      this.token.split('%2A')[1]
    console.log(this.loginUid)
    this.getCountInfo()
    document.title = '信息确认'
    this.handleCutdown()
  },
  methods: {
    // 从地址栏获取
    getcommit(name) {
      return (
        decodeURIComponent(
          (new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(
            location.href
          ) || ['', ''])[1].replace(/\+/g, '%20')
        ) || false
      )
    },
    // 获取账号合并信息
    async getCountInfo() {
      let params = Qs.stringify({ token: this.token })
      let res = await this.$api.getCountInfo(params)
      console.log(res)
      if (res.data.control.status == 200) {
        // 合并展示信息
        this.infoList = res.data.data.list.slice(1)
        this.mainUser = res.data.data.info.mainUser
        this.otherUser = res.data.data.info.thirdInfo
      }else{
        Toast('信息获取失败,请稍后')
      }
    },
    // 处理倒计时
    handleCutdown() {
      setInterval(() => {
        if (this.cutdown > 0) {
          this.cutdown--
        } else {
          this.canMerge = true
        }
      }, 1000)
    },
    // 点击确认合并
    gotoMerge() {
      if (this.canMerge) {
        console.log('点击确认合并')
        this.infoDialogIsShow = true
      }
    },
    // 再次点击确认合并
    async confirmMerge() {
      this.loadingIsShow = true
      console.log('真的要合并了')
      let params = Qs.stringify({
        mainUserId: this.mainUser.userId,
        userId: this.otherUser.userId,
        loginUserId: this.loginUid
      })
      let res = await this.$api.mergeCount(params)
      console.log(res)
      if (res.data.control.status == 200) {
        this.loadingIsShow = false
        this.infoDialogIsShow = false
        Toast('账号合并成功，请重新登录。')
        setTimeout(() => {
          this.accountMerge(2)
        }, 2000);
      } else {
        this.loadingIsShow = false
        console.log('合并失败')
        this.failDialogIsShow = true
      }
    },
    // 点击底部取消按钮
    handelCancel() {
      console.log('点击底部取消按钮')
      this.accountMerge(1)
    },
    // 弹窗点击取消
    cancelMerge() {
      this.infoDialogIsShow = false
    },
    // 合并失败后点击好的
    handleCancelMerge() {
      this.infoDialogIsShow = false
      this.failDialogIsShow = false
    },
    // 拨打客服电话
    callPhone(tel) {
      this.$NATIVE.oldfun.o_callPhone(tel)
    },
    // 两端交互
    accountMerge(status) {
      const nativeParams = {
        command: 'accountMerge',
        params: {
          status //1:返回账号管理；2：合并成功
        }
      }
      this.$NATIVE.newfun.n_nativeAction(nativeParams)
    }
  }
}
</script>

<style lang="less" scoped>
.information {
  width: 100vw;
  min-height: 100vh;
  padding-bottom: 2rem;
  .desc {
    padding: 0.6rem 0.4rem;
    font-size: 0.3rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 0.44rem;
  }
  .mergeTitle {
    padding-left: 0.4rem;
    padding-bottom: 0.32rem;
    font-size: 0.3rem;
    font-family: PingFang-SC-Bold, PingFang-SC;
    font-weight: bold;
    color: #000000;
    line-height: 0.44rem;
  }
  .userInfoBox {
    padding: 0 0.4rem 0.28rem 0.4rem;
    .smallTitle {
      font-size: 0.26rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
    .userInfo {
      width: 6.7rem;
      height: 1.04rem;
      margin-top: 0.16rem;
      margin-bottom: 0.32rem;
      padding: 0.2rem 0.3rem;
      box-sizing: border-box;
      background: #f5f5f5;
      border-radius: 0.1rem;
      display: flex;
      align-items: center;
      .userImg {
        width: 0.64rem;
        height: 0.64rem;
        border-radius: 50%;
        overflow: hidden;
        margin-right: 0.2rem;
        img {
          width: 0.64rem;
          height: 0.64rem;
        }
      }
      .userName {
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
      }
    }
  }
  .infoListBox {
    padding: 0 0.2rem 1rem 0.2rem;
    .tips {
      padding-left: 0.2rem;
      margin-bottom: 0.4rem;
      font-size: 0.3rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 0.44rem;
    }
    .infoList {
      // width: 7.1rem;
      box-sizing: border-box;
      border: 0.02rem solid rgba(153, 153, 153, 0.5);
    }
    .infoHeader {
      display: flex;
      background: #646566;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      line-height: 0.36rem;
      .header {
        box-shadow: none;
      }
    }
    // 表格
    .tableItem {
      flex: 1;
      height: 0.88rem;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding-left: 0.3rem;
      box-shadow: inset -1px 0px 0px 0px #e6e6e6;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-box-orient: vertical;
      // -webkit-line-clamp: 1;
      // word-break: break-all;
    }
    .nameOne,
    .nameThree {
      span {
        width: 1.2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        word-break: break-all;
      }
    }
    // 单独处理
    .lineItem {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.12rem 0.2rem 0.14rem 0.3rem;
      .title {
        width: 100%;
        font-size: 0.2rem;
        line-height: 0.28rem;
        margin-bottom: 0.06rem;
      }
      .name {
        width: 100%;
        line-height: 0.28rem;
        font-size: 0.24rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        word-break: break-all;
      }
    }
    .rowItem {
      display: flex;
      background: #fafbfc;
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
    .evenItem {
      background: #f2f3f5;
    }
    .item1 {
      // flex-basis: 2.08rem;
      flex: 0 0 2.08rem;
      padding: 0 0.3rem;
    }
    .redWord {
      font-size: 0.24rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ff1919;
    }
  }
  // 按钮
  .btnBox {
    width: 100vw;
    // height: 3rem;
    position: fixed;
    bottom: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 33%);
    padding-bottom: constant(safe-area-inset-bottom);
    /* 兼容 iOS < 11.2 */
    padding-bottom: env(safe-area-inset-bottom);
    /* 兼容 iOS >= 11.2 */
    .btns {
      display: flex;
      justify-content: space-between;
      margin-top: 1.2rem;
      padding: 0 0.48rem 0.2rem 0.48rem;
      .btnItem {
        width: 3.03rem;
        height: 0.92rem;
        background: #f8f9fa;
        border-radius: 0.45rem;
        font-size: 0.32rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .redBtn {
        background: #e9001d;
        color: #ffffff;
      }
    }
  }
  // 确认弹窗
  .dialogBox {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 5;
    .dialog {
      width: 5.2rem;
      // height: 3.38rem;
      background: #ffffff;
      border-radius: 0.2rem;
      box-sizing: border-box;
      padding: 0.4rem 0.3rem 0.3rem 0.3rem;
      .dTitle {
        text-align: center;
        font-size: 0.34rem;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;
        line-height: 0.48rem;
      }
      .dInfo {
        margin: 0.2rem 0 0.4rem;
        text-align: center;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 0.4rem;
        span {
          color: cornflowerblue;
        }
      }
      .dBtns {
        display: flex;
        justify-content: space-between;
        .btn {
          width: 2.2rem;
          height: 0.8rem;
          background: #f7f8fa;
          border-radius: 0.45rem;
          display: flex;
          justify-content: center;
          align-items: center;

          font-size: 0.28rem;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
        .redone {
          font-size: 0.28rem;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #e9001d;
        }
      }
    }
  }
  // 失败弹窗
  .failDialog {
    .dialog {
      .dBtns {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
